import { ProductUsageEnum } from "@shared/enums";

export const PRODUCT_USAGE_LABELS: Readonly<Record<ProductUsageEnum, string>> = {
  [ProductUsageEnum.LANDSCAPE]: "Paesaggi",
  [ProductUsageEnum.SPORT]: "Sport",
  [ProductUsageEnum.WILDLIFE]: "Animali",
  [ProductUsageEnum.VIDEO]: "Video",
  [ProductUsageEnum.STREET]: "Street",
  [ProductUsageEnum.PORTRAIT]: "Ritratti",
  [ProductUsageEnum.REPORTAGE]: "Eventi",
  [ProductUsageEnum.TRAVEL]: "Viaggio",
  [ProductUsageEnum.MACRO]: "Macro",
  [ProductUsageEnum.STARS]: "Stelle",
  [ProductUsageEnum.MOON]: "Luna",
  [ProductUsageEnum.STUDIO]: "Studio",
  [ProductUsageEnum.ASTRO]: "Astrofotografia",
};
